import { createSlice } from "@reduxjs/toolkit";

// initial camera form
export const initialCameraForm={
    name:"",
    description:"",
    ip_address:"",
    password:"",
    tags:[],
    preschool_id: "",
}

export const initialEditCameraForm={
    name:"",
    description:"",
    ip_address:"",
    password:"",
    tags:[],
    preschool_id:"",
    camera_feed_id:"",
}

// initial state for security
const initialState={
   popup:{
        cameraPopup:false,
        editCameraPopup: false,
        deleteCameraPopup: false
   },
   form:{
        cameraForm:initialCameraForm,
        editCameraForm : initialEditCameraForm
   },
   other:{
    camera_feed_id:null
  }
}

// initial state for security
const securitySlice=createSlice({
    name:'security',
    initialState,
    reducers:{
        // reducers for popup
        openCameraPopup:(state)=>{
            state.popup.cameraPopup=true
        },
        closeCameraPopup:(state)=>{
            state.popup.cameraPopup=false
        },
        openEditCameraPopup:(state, action)=>{
            state.popup.editCameraPopup=true
            state.form.editCameraForm=action.payload
        },
        closeEditCameraPopup:(state)=>{
            state.popup.editCameraPopup=false
            state.form.editCameraForm=initialEditCameraForm
        },
        openDeleteCameraPopup:(state, action)=>{
            state.popup.deleteCameraPopup=true
            state.other.camera_feed_id=action.payload
        },
        closeDeleteCameraPopup:(state)=>{
            state.popup.deleteCameraPopup=false
            state.other.camera_feed_id=null
        },

        // reducer for form
        addCameraForm:(state, action)=>{
            state.form.cameraForm=action.payload
        },
        editCameraForm:(state, action)=>{
            state.form.editCameraForm=action.payload
        }
    }
})

export const {openCameraPopup, closeCameraPopup, addCameraForm, openEditCameraPopup, 
closeEditCameraPopup, openDeleteCameraPopup, closeDeleteCameraPopup, editCameraForm}=securitySlice.actions

// get state for popup
export const getCameraPopup = (state) => state.security.popup.cameraPopup
export const getDeleteCameraPopup = (state) => state.security.popup.deleteCameraPopup
export const getEditCameraPopup = (state) => state.security.popup.editCameraPopup

// get state for form
export const getCameraForm = (state) => state.security.form.cameraForm
export const getEditCameraForm = (state) => state.security.form.editCameraForm
export const getCameraFeedId = (state) => state.security.other.camera_feed_id


export default securitySlice.reducer